// src/lib/hooks/admin/useUsageTimeseries.ts
import { useQuery } from '@tanstack/react-query';
import { fetchUsageTimeseries } from '@/lib/api/admin';
import type { UsageFilters, TimeseriesPoint } from '@/types/admin';
import { usageKeys } from './useUsageOverview';

export const useUsageTimeseries = (filters: UsageFilters, enabled = true) => {
  return useQuery<TimeseriesPoint[]>({
    queryKey: usageKeys.timeseries(filters),
    queryFn: () => fetchUsageTimeseries(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
